// extracted by mini-css-extract-plugin
export default {"content":"Global_content__qVK4J","testCSS":"Global_testCSS__V8SF3"};